import { Injectable } from '@angular/core';
import { Globals } from '../../globals';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MdhlSetting } from '../modal/mdhlSetting';

@Injectable({
    providedIn: 'root'
})

export class MdhlSettingService {
    constructor(private global: Globals, private _httpClient: HttpClient) { }
    getMdhlSetting() {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this._httpClient.get<MdhlSetting>(this.global.G_apiUrl +'/mdhlSetting',{headers:headers});
    }
}